import React from "react";
import { useUserContext } from "context/UserContext";
import MarketDataAnalysisBK from "layouts/BK/marketDataAnalysis";
import { isBkLikeRole } from "utils/roleUtils";

function MarketDataAnalysis() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role)) {
    return <MarketDataAnalysisBK />;
  }
  return null;
}

export default MarketDataAnalysis;
